// @flow

export default {
  METERS: 'm',
  KILOMETERS: 'km'
};
